import { IGetLectureAdvance, ILectureAdvance } from './type'
import { http } from '../http'
import { Config } from '../../host'

/**
 * 用于缓存课程播放信息请求的Promise对象
 * key格式为: `${liveroom_id}_${channel_id}_${lecture_id}`
 */
const lectureAdvanceCachePromise: {
  [key: string]: Promise<ILectureAdvance>
} = {}

/**
 * 获取课程播放信息
 * @param params - 请求参数对象
 * @param params.liveroom_id - 直播间ID
 * @param params.channel_id - 频道ID
 * @param params.lecture_id - 课程ID
 * @param cache - 是否启用缓存
 *               true: 相同参数的请求会返回缓存的结果
 *               false: 每次都重新请求数据
 * @returns Promise<ILectureAdvance> - 返回课程播放信息
 */
export function getLectureAdvance(params: IGetLectureAdvance, cache?: boolean) {
  const key = `${params.liveroom_id}_${params.channel_id}_${params.lecture_id}`
  if (cache && lectureAdvanceCachePromise[key]) {
    return lectureAdvanceCachePromise[key]
  }
  const result = http.get<ILectureAdvance>(
    '/v1/integration/cont_manager/v1/api/lecture.lectures.advance_get',
    params,
    Config.GATEWAY_NEW_URL
  )
  if (cache) {
    lectureAdvanceCachePromise[key] = result
  }
  return result
}
